import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

/**
 * Hook que busca a sugestão de compra calculada pelo backend para um produto + loja.
 *
 * @param {Object} params
 * @param {string} params.codigo         — código do produto (codigo_interno na fisica, codigo na ecommerce)
 * @param {('centro'|'caxias'|'ecommerce'|'todas')} params.loja
 * @param {string} [params.fornecedor]   — nome do fornecedor (melhora cálculo de lead time)
 * @param {number} [params.estoque]      — passe se já tiver, evita 1 query extra no backend
 * @param {number} [params.precoCusto]   — para cálculo de markup nos alertas
 * @param {number} [params.precoVenda]   — para cálculo de markup nos alertas
 * @param {boolean} [params.enabled=true]
 */
export const useSugestaoCompra = ({
    codigo,
    loja,
    fornecedor,
    estoque,
    precoCusto,
    precoVenda,
    enabled = true,
    cacheOnly = true  // default: só usa cache populada por batch — evita lentidão de live compute
}) => {
    return useQuery({
        queryKey: ['sugestaoCompra', codigo, loja, fornecedor, cacheOnly],
        queryFn: async () => {
            const params = new URLSearchParams();
            if (loja) params.set('loja', loja);
            if (fornecedor) params.set('fornecedor', fornecedor);
            if (estoque !== undefined && estoque !== null) params.set('estoque', estoque);
            if (precoCusto !== undefined && precoCusto !== null) params.set('precoCusto', precoCusto);
            if (precoVenda !== undefined && precoVenda !== null) params.set('precoVenda', precoVenda);
            if (cacheOnly) params.set('cacheOnly', 'true');

            const { data } = await axios.get(
                `/api/produtos/sugestao-compra/${encodeURIComponent(codigo)}?${params.toString()}`
            );
            return data;
        },
        enabled: enabled && !!codigo,
        staleTime: 15 * 60 * 1000,  // cache local 15min — coerente com batch hourly/daily
        retry: 1
    });
};
